import { render } from "./AppLight.vue?vue&type=template&id=5fac9a3c"
import script from "./AppLight.vue?vue&type=script&lang=js"
export * from "./AppLight.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__